import React from 'react'
import Flex from 'typescript-styled-flex'
import { useTranslation } from 'react-i18next'
import { theme } from '../../theme'
import { Color } from '../ColorPalette'
import { useFormatTime } from '../../hooks/useFormatTime'
import useFormatDate from '../../hooks/useFormatDate'
import expanderContainer from './expanderContainer'
import HeaderLabel from './HeaderLabel'
import DateLabel from './DateLabel'

function NestedNotification(notification, index, createdAt, type, size = 1) {
  const formatTime = useFormatTime()
  const formatDate = useFormatDate()
  const { t } = useTranslation()

  return (
    <Flex
      column={true}
      style={{
        background: 'white',
        borderBottom: `1px solid ${theme.colors.palette.lightGrey}`,
        borderRadius: '6px',
        marginBottom: `${8 * size}px`,
        width: '100%',
      }}
    >
      <Flex style={{ padding: `${18 * size}px` }}>
        <Color
          size={size}
          static={true}
          style={{
            fontFamily: 'Open Sans',
            fontSize: `${16 * size}px`,
            fontWeight: 'bold',
            margin: `0px ${20 * size}px`,
            marginLeft: '0px',
          }}
          width={`${32 * size}px`}
          height={`${32 * size}px`}
          color={theme.colors.palette.slateGrey}
        >
          {index}
        </Color>

        <Flex column={true} style={{ width: '100%' }}>
          <Flex column={true}>
            <HeaderLabel size={size}>
              {type === 'ICal'
                ? t('BBO_930_ICal_conflict')
                : type === 'Airbnb'
                ? t('OUT_4834_conflict_airbnb')
                : t('BBO_930_booking_conflict')}
            </HeaderLabel>
            <DateLabel size={size}>{`${formatDate(createdAt)} ${formatTime(
              createdAt,
            )}`}</DateLabel>
          </Flex>
        </Flex>
      </Flex>
      <Flex column={true} justifyBetween={true}>
        {expanderContainer(notification, size)}
      </Flex>
    </Flex>
  )
}

export default NestedNotification
